import { render, staticRenderFns } from "./afterSaleNoTable.vue?vue&type=template&id=3d37227a&scoped=true&"
import script from "./afterSaleNoTable.vue?vue&type=script&lang=js&"
export * from "./afterSaleNoTable.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleNoTable.vue?vue&type=style&index=0&id=3d37227a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37227a",
  null
  
)

export default component.exports